export const SleepTipsRelaxationStoriesData = [
  {
    id: 1,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip1.png'),
    recommendation: 'Pred spaním môžete zvýšiť kvalitu svojho spánku natiahnutím a meditatívnymi cvičeniami.',
  },
  {
    id: 2,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip2.png'),
    recommendation: 'Udržujte spálňu na príjemnej, chladnej teplote s prístupom k čerstvému vzduchu.',
  },
  {
    id: 3,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip3.png'),
    recommendation: 'Pred spaním držte telefón ďalej. Vydáva modré svetlo, ktoré je podobné slnečnému svetlu. Tento druh svetla vás môže udržať hore v noci, pretože klame váš mozog, že je deň.',
  },
  {
    id: 4,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip4.png'),
    recommendation: 'Pred spaním skúste zhlboka dýchať, aby ste si vyčistili myseľ.',
  },
  {
    id: 5,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip5.png'),
    recommendation: 'Snažte sa chodiť spať a vstávať v rovnakom čase každý deň, aj cez víkendy.',
  },
  {
    id: 6,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip6.png'),
    recommendation: 'Pred spaním snívajte o veciach, na ktoré sa tešíte vo svojom živote. Pomôže vám to ľahšie zaspať.',
  },
  {
    id: 7,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip7.png'),
    recommendation: 'Zvyk vziať si teplú sprchu pred spaním a vypiť pohár teplého mlieka vám môže pomôcť relaxovať.',
  },
  {
    id: 8,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip8.png'),
    recommendation: 'Pred spaním myslite na veci, ktoré vás robia šťastnými, nie smutnými.',
  },
  {
    id: 9,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip9.png'),
    recommendation: 'Nejedzte ťažké jedlo pred spaním a ani sa nehladujte.',
  },
  {
    id: 10,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip10.png'),
    recommendation: 'Vyberte si pohodlné posteľné prádlo, aby ste neboli ani horúci, ani studený.',
  }
];

export const BetterSleepTipsStoriesData = [
  {
    id: 1,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/better-sleep/tip1.png'),
    recommendation: 'Keď vás bolí rameno, nespite na ňom; namiesto toho spite na chrbte s vankúšom objatým k hrudi.',
  },
  {
    id: 2,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/better-sleep/tip2.png'),
    recommendation: 'Ak často trpíte pálením záhy, skúste spať na ľavej strane s hlavou podopretou veľkým vankúšom.',
  },
  {
    id: 3,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/better-sleep/tip3.png'),
    recommendation: 'Na zmiernenie bolesti chrbta skúste pred spaním umiestniť medzi nohy ďalší vankúš.',
  },
  {
    id: 4,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/better-sleep/tip4.png'),
    recommendation: 'Keď vás zasiahne bolesť srdca, snažte sa nespať na boku — táto poloha môže zaťažiť vaše srdce. Ležanie na chrbte a hlboký nádych môžu zmierniť bolesť.',
  },
  {
    id: 5,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/better-sleep/tip5.png'),
    recommendation: 'Bolesť krku. Často meňte svoje vankúše a uprednostňujte latexové.',
  },
  {
    id: 6,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/better-sleep/tip6.png'),
    recommendation: 'Bolesť dolnej časti chrbta. Tesne pred spaním ohnite nohy a umiestnite medzi ne vankúš.',
  },
  {
    id: 7,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/better-sleep/tip7.png'),
    recommendation: 'Snažte sa spať na chrbte. Táto poloha je najvhodnejšia pre telo.',
  },
  {
    id: 8,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/better-sleep/tip8.png'),
    recommendation: 'Ak máte upchatý nos, použite vyšší vankúš. Ležte na chrbte s hlavou čo najvyššie.',
  }
];